import ReactDOM from "react-dom/client";
import React from "react";

import '@livekit/components-styles';
import '@livekit/components-styles/prefabs';
import EgressHelper from '@livekit/egress-sdk';
import RoomPage from "./component/Room";
import {createStore} from "./utils/store";
import Game501 from "./model/501";
import _video from "./model/_video";

const App = createStore(function () {
  return (
    <React.Suspense fallback={<>...</>}>
      <RoomPage
        // url={EgressHelper.getLiveKitURL()}
        url={URLS.video_ws}
        token={EgressHelper.getAccessToken()}
        // layout={EgressHelper.getLayout()}
      />
    </React.Suspense>
  )
}, {
  Game: Game501,
  Video: _video
}, {
  game: window.INIT_DATA || {},
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App/>);